import React, { useState, useEffect } from "react";
import { Form, Select, InputNumber, Tooltip, Input, Typography, Switch } from "antd";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { elvis } from "../../Utils";

const { Option } = Select;
const { Title } = Typography;

const TlcComponentDamageForm = props => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [damageLevelTypes, setDamageLevelTypes] = useState([]);

  const formItemLayout = {
    labelCol: {
      sm: { span: 8 }
    },
    wrapperCol: {
      sm: { span: 16 }
    }
  };

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_ENDPOINT + "/telecommunication/enums/damage-levels")
      .then(({ data }) => {
        setDamageLevelTypes(data);
      })
      .catch(function(error) {
        console.log(error);
      });
  }, [props.record.asset]);

  // Add effect to update form values when damage data changes
  useEffect(() => {
    if (props.record.damage) {
      form.setFieldsValue({
        reachable: props.record.damage.reachable,
        networkDamageLevel: props.record.damage.networkDamageLevel
      });
    }
  }, [props.record.damage, form]);
  
  // Since the original component didn't have change handlers, add minimal ones
  const onValuesChange = (changedValues) => {
    if (props.record && props.parentCallback) {
      const values = form.getFieldsValue();
      const newDamage = { ...props.record };
      
      // Update the damage properties with form values
      if (newDamage.damage) {
        newDamage.damage.reachable = values.reachable;
        newDamage.damage.networkDamageLevel = values.networkDamageLevel;
      }
      
      props.parentCallback(newDamage);
    }
  };
  
  return (
    <Form 
      {...formItemLayout} 
      className="details_form"
      form={form}
      onValuesChange={onValuesChange}
      name="tlcComponentDamage"
    >
      <Title className="details_form_header"
        title="Damages details"
        subTitle="Network Service"
      />
      <Form.Item label="Reachable" name="reachable" valuePropName="checked">
        <Switch />
      </Form.Item>
      <Form.Item
        label="Damage level"
        name="networkDamageLevel"
        tooltip="Damage level"
      >
        <Select>
          {damageLevelTypes.map(name => (
            <Option key={name} value={name}>
              {t('telecommunicationEnums.damageLevel.' + name, name)}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </Form>
  );
};

export default TlcComponentDamageForm;